 import React from 'react';
import '../../App.css'; 
import { Link, NavLink } from 'react-router';
import ResearchSidebar from '../../Components/ResearchSidebar';

const Surveys = () => {
  return (
    <main className="dashboard-layout">
      <ResearchSidebar />
      <div className="dashboard-content">
        <h1 className="page-title">Surveys</h1>
        <p>This page will be used to manage survey questions.</p>
      </div>
    </main>
  );
};

export default Surveys;